
import { Col, Row } from "react-bootstrap";
import "../Css/groove_pdf.css";

const WiPdfTubeToTubesheet2Hindi = ({ wi, rowdata, wpsde, setpdf }, props, wld) => {

  let header = rowdata[0];
  let detail = rowdata[1];
  let slipDate = header?.WI_SlipDate;
  let date = new Date(slipDate);
  let formattedDate = date.getDate() + "/" + (date.getMonth() + 1) + "/" + date.getFullYear();
  const tradeName = detail?.WPSD_FM_ChemicalAnalysis_TradeName || '';
  const firstPart = tradeName?.slice(0, 18);
  const secondPart = tradeName?.slice(17);
  const AllNotes = header?.WI_NOTES.split('\n');
  const Notes = AllNotes.slice(0, 6);

  return (
    <div className="MainPDF">
      <header>
        <table className="tablenoborder">
          <div style={{ display: "flex" }}>
            <tr>
              <td className="tablenoborder godrejTitle" align="left" valign="top" style={{ fontWeight: "200" }}>
                Godrej & Boyce Mfg. Co. Ltd
              </td>
            </tr>
            <tr>
              <td className="tablenoborder godrejAddress"
                align="right"
                valign="top"
                style={{ position: "relative", left: "390px" }}>
                {header?.WI_print >= 1
                  ? `Reprinted On: ${new Date().toLocaleDateString("en-GB")}`
                  : ""}{" "}
              </td>
            </tr>
          </div>
          <tr>
            <td
              className="tablenoborder godrejAddress "
              align="right"
              style={{ position: "relative", right: "50px" }}
            >
              प्रिन्ट दिनांक : {formattedDate}
            </td>
          </tr>
          <tr>
            <td className="tablenoborder pageTitle" align="center" valign="top" style={{ verticalAlign: "top", padding: 0, height: ".1%" }}            >
              वेल्डिंग कनसुमेबल रीकविजिसन / इन्स्ट्रक्शन स्लीप ( मांग और निर्देश पत्र )
            </td>
          </tr>
          <div className="borderline"></div>
        </table>
        <div className="welding-slip">
          <div className="rowa row-2cola">
            <div className="cella">
              <span className="labela">वेल्डर :</span>
              <span className="valuea">{header?.WI_Welder_Id}/{header?.WI_Welder_Name}</span>
            </div>
            <div className="cella">
              <span className="labela">स्लीप नं :</span>
              <span className="valuea">PED/{header?.WI_plant}/{header?.SK}</span>
            </div>
          </div>
          <div className="rowa row-2cola">
            <div className="cella">
              <span className="labela">WPS No:</span>
              <span className="valuea">{detail?.WPSH_WPS_No}</span>
              <span className="labela">रिवीजन नं :</span>
              <span className="valuea">{header?.WPS_Rev_no}</span>
            </div>
            <div className="cella">
              <span className="labela">वेल्डिंग पोजिशन :</span>
              <span className="valuea">{header?.WI_Welding_Position}</span>
            </div>
          </div>
          <div className="rowa row-2cola">
            <div className="cella">
              <span className="labela">प्रोजेक्ट :</span>
              <span className="valuea">{header?.WI_Project_No}</span>
            </div>
            <div className="cella">
              <span className="labela">सीम / जॉइंट नं :</span>
              <span className="valuea">{header?.WI_Joint_No}</span>
            </div>
          </div>
          <div className="rowa row-2cola">
            <div className="cella">
              <span className="labela">जॉइंट डिजाइन :</span>
              <span className="valuea">As per drawing</span>
            </div>
            <div className="cella">
              <span className="labela">प्रोसेस :</span>
              <span className="valuea">{detail?.WPSDProcessCat} / {detail?.WPSDType}</span>
            </div>
          </div>
        </div>
        <div>
          <br></br>
          <div>
            <div className="ReportHeadersleft" align="left">
              सूचना :
            </div>
          </div>
        </div>
        <Row style={{ display: "flex" }}>
          <Col md={4} style={{ display: "flex", width: "390px" }}>
            (१) न्यूनतम प्रीहिट टेम्परेचर : {detail.WPSD_WP_MinimumPreheatTemp} °C
          </Col>
          <Col md={4} style={{ display: "flex" }}>
            (४) इंसुलेसन मटीरीअल मे ढकता  है : {header?.WI_Wrap_Insulation}
          </Col>
        </Row>
        <Row style={{ display: "flex" }}>
          <Col md={4} style={{ display: "flex", width: "390px" }}>
            (२) अधिकतम इंटपास टेम्परेचर : {detail.WPSD_WP_MaximumInterpassTemp} °C
          </Col>
          <Col md={4} style={{ display: "flex", width: "390px" }}>
            (५) इलेक्ट्रोड ड्रॉन मस्ट बी कीप्ट इन पोर्टेबल ओवन
          </Col>
        </Row>
        <Row style={{ display: "flex" }}>
          <Col md={6} style={{ display: "flex" }}>
            (३) पोस्ट हिट टेम्परेचर : {detail.WPSD_WP_PostHeating}
          </Col>
        </Row>
        <br></br>
        <table className="Table50">
          <tbody>
            <tr>
              <th
                className="wider-cell1"
                style={{

                  border: "none",
                  borderTop: "1px solid black",
                  borderLeft: "1px solid black",
                  width: "330px",
                }}
              >

                <span className="tabledata" style={{ width: "70px" }}>फिलर मेटल:  AWS:</span>
                <td className="tableheadingd" style={{ borderLeft: "0px", fontWeight: "100" }}>{header.WI_FM_AWS}</td>

              </th>
              <th style={{ textAlign: "center", borderRight: "0" }}>
                <span className="tableheading">
                  डायमीटर <br></br>(mm){" "}
                </span>
              </th>
              <th style={{ textAlign: "center", width: "190px", borderRight: "0" }}>
                <span className="tableheading" style={{ paddingBottom: "10px" }}>
                  बैच संख्या
                </span>
              </th>
              <th style={{ textAlign: "center", borderRight: "0" }}>
                <span className="tableheading">लेयर</span>
              </th>
              <th style={{ textAlign: "center", borderRight: "0" }}>
                <span className="tableheading">करंट पॉलारीति </span>
              </th>
              <th style={{ textAlign: "center", borderRight: "0" }}>
                <span className="tableheading">करंट (Ampere)</span>
              </th>
              <th style={{ textAlign: "center", borderRight: "0" }}>
                <span className="tableheading">वॉलटेज (Volts)</span>
              </th>
              <th style={{ textAlign: "center", borderRight: "0" }}>
                <span className="tableheading">
                  स्पीड  <br></br>(mm/min)
                </span>
              </th>
              <th style={{ textAlign: "center", width: "30px" }}>
                <span className="tableheading">संख्या /मात्रा </span>
              </th>
            </tr>
            <tr>
              <td className="tabledata" style={{ width: "70px", borderLeft: "1px solid black" }} >
                ब्रांड :
              </td>
              <td className="tableheadingd" style={{ borderLeft: "1px solid black" }}>
                {header?.WI_FillerMetalSize[0]}
              </td>
              <td className="tableheadingd">{header?.WI_WP_BatchNumber[0]} </td>
              <td className="tableheadingd">
                {detail?.WPSD_WP_LayerNumber[0]
                  ? detail?.WPSD_WP_LayerNumber[0]
                  : ""}
              </td>
              <td className="tableheadingd">
                {detail?.WPSD_WP_CurrentPolarity[0]
                  ? detail?.WPSD_WP_CurrentPolarity[0]
                  : ""}
              </td>
              <td className="tableheadingd">
                {detail?.WPSD_WP_Amperes[0] ? detail?.WPSD_WP_Amperes[0] : ""}
              </td>
              <td className="tableheadingd">
                {detail?.WPSD_WP_Volts[0] ? detail?.WPSD_WP_Volts[0] : ""}
              </td>
              <td className="tableheadingd">
                {detail?.WPSD_WP_TravelSpeed[0]
                  ? detail?.WPSD_WP_TravelSpeed[0]
                  : ""}
              </td>
              <td className="tableheadingd"></td>
            </tr>
            <tr>
              <td className="tableheadingd"> {firstPart}</td>
              <td
                className="tableheadingd"
                style={{ borderLeft: "1px solid black" }}
              >
                {header?.WI_FillerMetalSize[1]}
              </td>
              <td className="tableheadingd">{header?.WI_WP_BatchNumber[1]}</td>
              <td className="tableheadingd">
                {detail?.WPSD_WP_LayerNumber[1]
                  ? detail?.WPSD_WP_LayerNumber[1]
                  : ""}
              </td>
              <td className="tableheadingd">
                {detail?.WPSD_WP_CurrentPolarity[1]
                  ? detail?.WPSD_WP_CurrentPolarity[1]
                  : ""}
              </td>
              <td className="tableheadingd">
                {detail?.WPSD_WP_Amperes[1] ? detail?.WPSD_WP_Amperes[1] : ""}
              </td>
              <td className="tableheadingd">
                {detail?.WPSD_WP_Volts[1] ? detail?.WPSD_WP_Volts[1] : ""}
              </td>
              <td className="tableheadingd">
                {detail?.WPSD_WP_TravelSpeed[1]
                  ? detail?.WPSD_WP_TravelSpeed[1]
                  : ""}
              </td>
              <td className="tableheadingd"></td>
            </tr>
            <tr>
              <td
                className="tableheadingd">
                {secondPart ? secondPart : ""}
              </td>
              <td
                className="tableheadingd"
                style={{ borderLeft: "1px solid black" }}
              >
                {header?.WI_FillerMetalSize[2]}
              </td>
              <td className="tableheadingd">{header?.WI_WP_BatchNumber[2]}</td>
              <td className="tableheadingd">
                {detail?.wld_WPSType === "Groove"
                  ? detail?.WPSD_WP_LayerNumber[2]
                  : ""}
              </td>
              <td className="tableheadingd">
                {detail?.WPSD_WP_CurrentPolarity[2]
                  ? detail?.WPSD_WP_CurrentPolarity[2]
                  : ""}
              </td>
              <td className="tableheadingd">
                {detail?.WPSD_WP_Amperes[2] ? detail?.WPSD_WP_Amperes[2] : ""}
              </td>
              <td className="tableheadingd">
                {detail?.WPSD_WP_Volts[2] ? detail?.WPSD_WP_Volts[2] : ""}
              </td>
              <td className="tableheadingd">
                {detail?.WPSD_WP_TravelSpeed[2]
                  ? detail?.WPSD_WP_TravelSpeed[2]
                  : ""}
              </td>
              <td className="tableheadingd"></td>
            </tr>
          </tbody>
        </table>
        <table className="Table50">
          <tbody>
            <tr>
              <th className="wider-cell" style={{ borderTop: "0px" }}>
                <span
                  className="tabledata"
                  style={{
                    borderRight: "0px",
                    borderLeft: "0px",
                    borderTop: "0px",
                  }}
                >
                  वेल्डिंग गैस :
                </span>
              </th>
              <th
                className="wider-cel"
                style={{
                  width: "110px",
                  borderTop: "0px",
                  borderLeft: "0px",
                  borderRight: "1px solid black",
                }}
              >
                <span className="tabledata">टाइप / मिश्रण</span>
              </th>
              <th className="wider-ce" style={{ width: "110px", borderTop: "0px", borderLeft: "0px", }}              >
                <span className="tabledata">
                  फ्लो रेट लिटर्स/मिनिट
                </span>
              </th>
              <th
                className="wider-ce"
                style={{
                  border: "none",
                  borderRight: "1px solid black",
                  borderTop: "0px",
                  width: "160px",
                }}
              >
                <span className="tableheading2">फ्लक्स : : {header?.WI_Flux}</span>
              </th>
            </tr>
            <tr>
              <td
                className="tableheadingL"
                style={{ borderRight: "1px solid black" }}
              >
                शीलडिग
              </td>
              <td className="tableheadingL" style={{ borderRight: "1px solid black" }}>
                {detail?.WPSD_WP_ShieldingGasType}
              </td>
              <td className="tableheadingL" style={{ borderRight: "1px solid black" }}>
                {detail?.WPSD_WP_ShieldingFlowRate}
              </td>
              <td
                className="tableheadingL"
                style={{ borderRight: "1px solid black" }}
              >
                ब्रांड : {header?.WI_Flux_Brand}
              </td>
            </tr>
            <tr>
              <td
                className="tableheadingL"
                style={{ borderRight: "1px solid black" }}
              >
                बेकीनग / ट्रेलिंग
              </td>
              <td
                className="tableheadingL"
                style={{ borderRight: "1px solid black" }}
              >
                {detail?.WPSD_WP_BackingGasType}
              </td>
              <td
                className="tableheadingL"
                style={{ borderRight: "1px solid black" }}
              >
                {detail?.WPSD_WP_BackingFlowRate}
              </td>
              <td
                className="tableheadingL"
                style={{ borderRight: "1px solid black" }}
              >
                Flux Item: {header?.WI_Flux_ItemCode}
              </td>
            </tr>
            <tr>
              <td style={{ borderRight: "1px solid black" }}></td>
              <td style={{ borderRight: "1px solid black" }}></td>
              <td style={{ borderRight: "1px solid black" }}></td>
              <td className="tableheadingL" style={{ borderRight: "1px solid black" }}>
                Flux Batch: {header?.WI_Flux_Batch}
              </td>
            </tr>
          </tbody>
        </table>
        <br></br>
        <div>
          <div>
            <div className="ReportHeadersleft" align="left">
              सूचनाई (नोट्स) :
            </div>
            <div className="Reportdataleftnotes" align="left" style={{ width: "800px" }}>
              <div className="ReportHeadersleft" align="left">
                DC Pulsing Current: {detail.WPSD_WP_FillerMetalSIze[0]} : {detail.WPSD_WP_Pulsing_current[0]} , {detail.WPSD_WP_FillerMetalSIze[1]} : {detail.WPSD_WP_Pulsing_current[1]}
              </div>
              <div className="ReportHeadersleft" align="left">
                DC Pulsing Current - Others: {detail.WPSD_WP_FillerMetalSIze[0]} : {detail.WPSD_WP_Pulsing_current_others[0]} , {detail.WPSD_WP_FillerMetalSIze[1]} : {detail.WPSD_WP_Pulsing_current_others[1]}
              </div>
              {Notes.map((point, index) => (
                <div className="notefonts" key={point || `note-${index}`}>{point}</div>
              ))}
            </div>
          </div>
        </div>


        <div style={{ display: "flex", position: "relative", top: "40px" }}>
          <div style={{ display: "flex" }}>
            <div className="ReportHeadersleft" align="left">
              (शॉप सुपरवाएजर)
            </div>
          </div>
        </div>

        <table
          className="tablenoborder"
          style={{ position: "relative", top: "70px" }}
        >
          <tr>


            <td
              className="tablenoborder pageTitle"
              align="center"
              valign="top"
              style={{ verticalAlign: "top", padding: 0, height: ".1%", borderBottom: "1px solid black", borderTop: "1px solid black" }}
            >
              वेल्डिंग कनसुमेबल रीकविजिसन / इन्स्ट्रक्शन स्लीप ( मांग और निर्देश पत्र )
            </td>
          </tr>
        </table>




        <div style={{ position: "relative", top: "70px" }}>
          <div style={{ display: "flex" }}>
            <div className="Reportslipheadrightdate" align="right">
              तारीख : {formattedDate}

            </div>

          </div>

          <div style={{ display: "flex" }}>
            <div style={{ display: "flex" }}>
              <div className="ReportHeadersleft" align="left">
                वेल्डर :
              </div>
              <div
                className="Reportdataleft"
                align="left"
                style={{ width: "250px" }}
              >
                {header?.WI_Welder_Id}/{header?.WI_Welder_Name}
              </div>
            </div>
            <div style={{ display: "flex" }}>
              <div className="Reportslipheadright" align="right">
                स्लीप नं :
              </div>
              <div className="Reportslipnodata" align="right">
                {header?.WI_Slip}
              </div>
            </div>
          </div>

          <div style={{ display: "flex" }}>
            <div style={{ display: "flex" }}>
              <div className="ReportHeadersleft" align="left">
                प्रोजेक्ट :
              </div>
              <div
                className="Reportdataleft"
                align="left"
                style={{ width: "120px" }}
              >
                {header?.WI_Project_No}
              </div>
            </div>

            <div style={{ display: "flex" }}>
              <div className="ReportHeadersright" align="right">
                सीम / जॉइन्ट नं :
              </div>
              <div className="Reportdataright" align="right">
                {header?.WI_Joint_No}
              </div>
            </div>
          </div>

          <div style={{ display: "flex" }}>
            <div style={{ display: "flex" }}>
              <div className="ReportHeadersleft" align="left">
                WPS No:
              </div>
              <div
                className="Reportdataleft"
                align="left"
                style={{ width: "120px" }}
              >
                {detail?.WPSH_WPS_No}
              </div>
            </div>

            <div style={{ display: "flex" }}>
              <div className="ReportHeadersright1pg2" align="right">
                रिवीजन नं :
              </div>
              <div className="Reportdataright1pg2" align="right">
                {header?.WPS_Rev_no}{" "}
              </div>
            </div>

            <div style={{ display: "flex" }}>
              <div className="ReportHeadersright2pg2" align="right">
                प्रोसेस :
              </div>
              <div className="Reportdataright2pg2" align="right">
                {detail?.WPSDProcessCat} / {detail?.WPSDType}
              </div>
            </div>
          </div>
          <br></br>
          <table className="Table50">
            <tbody>
              <tr>
                <th className="wider-cell3" style={{ width: "200px" }}>
                  <span className="tabledata"></span>
                </th>
                <th className="wider-cell" style={{ borderRight: "1px solid black", borderLeft: "0" }} >
                  <span className="tableheading " style={{ borderRight: "0" }}>डायामीटर (mm)</span>
                </th>
                <th className="wider-cell" style={{ borderLeft: "0" }}>
                  <span className="tableheading" style={{ borderLeft: "0" }}>Batch No</span>
                </th>
                <th className="wider-cell2" style={{ borderLeft: "0" }}>
                  <span className="tableheading">आइटम कोड </span>
                </th>
                <th className="wider-cell" style={{ borderLeft: "0" }}>
                  <span className="tableheading">संख्या / मात्रा </span>
                </th>
              </tr>

              <tr>
                <td
                  className="tabledatad"
                  style={{ borderRight: "1px solid black" }}
                >
                  फिलर  मेटल  (AWS): {header.WI_FM_AWS}
                </td>
                <td
                  className="tabledatad"
                  style={{ borderRight: "1px solid black" }}
                >
                  {header?.WI_FillerMetalSize[0]}
                </td>
                <td
                  className="tabledatad"
                  style={{ borderRight: "1px solid black" }}
                >
                  {header?.WI_WP_BatchNumber[0]}                </td>
                <td
                  className="tabledatad"
                  style={{ borderRight: "1px solid black" }}
                >
                  {header?.WI_WeldConsumable[0] ? header?.WI_WeldConsumable[0] : ""}
                </td>
                <td
                  className="tabledatad"
                  style={{ borderRight: "1px solid black" }}
                >
                </td>
              </tr>
              <tr>
                <td
                  className="tabledatad"
                  style={{ borderRight: "1px solid black" }}
                >
                  ब्रांड : {header.WI_FM_Brand}
                </td>
                <td
                  className="tabledatad"
                  style={{ borderRight: "1px solid black" }}
                >
                  {header?.WI_FillerMetalSize[1]}
                </td>
                <td
                  className="tabledatad"
                  style={{ borderRight: "1px solid black" }}
                >
                  {header?.WI_WP_BatchNumber[1]}
                </td>
                <td
                  className="tabledatad"
                  style={{ borderRight: "1px solid black" }}
                >
                  {header?.WI_WeldConsumable[1] ? header?.WI_WeldConsumable[1] : ""}
                </td>
                <td
                  className="tabledatad"
                  style={{ borderRight: "1px solid black" }}
                >
                </td>
              </tr>
              <tr>
                <td
                  className="tabledatad"
                  style={{
                    borderRight: "1px solid black",
                    borderBottom: "1px solid black",
                  }}
                ></td>
                <td
                  className="tabledatad"
                  style={{
                    borderRight: "1px solid black",
                    borderBottom: "1px solid black",
                  }}
                >
                  {header?.WI_FillerMetalSize[2]}
                </td>
                <td
                  className="tabledatad"
                  style={{
                    borderRight: "1px solid black", borderBottom: "1px solid black",
                  }}
                >
                  {header?.WI_WP_BatchNumber[2]}
                </td>
                <td
                  className="tabledatad"
                  style={{
                    borderRight: "1px solid black",
                    borderBottom: "1px solid black",
                  }}
                >
                  {header?.WI_WeldConsumable[2] ? header?.WI_WeldConsumable[2] : ""}
                </td>
                <td
                  className="tabledatad"
                  style={{
                    borderRight: "1px solid black",
                    borderBottom: "1px solid black",
                  }}
                >
                </td>
              </tr>
              <tr>
                <td
                  className="tabledatad"
                  style={{ borderRight: "1px solid black" }}
                >
                  फ्लक्स : {header.WI_Flux}{" "}
                </td>
                <td
                  className="tabledatad"
                  colSpan={2}
                  style={{
                    borderRight: "none",
                  }}
                >
                  Item Code:
                </td>
                <td
                  className="tabledatad"
                  style={{
                    position: "relative", right: "50px",
                    borderRight: "none"
                  }}
                >
                  {header?.WI_Flux_ItemCode}
                </td>
                <td
                  className="tabledatad"
                  style={{
                    borderRight: "none",
                  }}
                ></td>
              </tr>
              <tr>
                <td className="tabledatad" style={{ borderRight: "1px solid black" }}>
                  ब्रांड : {header?.WI_Flux_Brand}
                </td>
                <td
                  className="tabledatad"
                  colSpan={2}
                  style={{
                    borderRight: "none",
                  }}
                >
                  संख्या / मात्रा :
                </td>
                <td
                  className="tabledatad"
                  style={{
                    borderRight: "none",
                  }}
                ></td>
                <td
                  className="tabledatad"
                  style={{
                    borderRight: "none",
                  }}
                ></td>
              </tr>
            </tbody>
          </table>

          <div className="ReportHeadersleft" align="left" style={{ position: "relative", top: "80px" }} >
            (स्टोर इंचार्ज)
          </div>
        </div>
      </header>
    </div>
  );
};

export default WiPdfTubeToTubesheet2Hindi;